import { Component, OnInit, OnDestroy } from '@angular/core';
import { InventarioService } from 'src/app/services/inventario.service';
import Swal from 'sweetalert2';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Facmanual } from 'src/app/models/Facmanual';

declare var $: any;

@Component({
  selector: 'app-listadxmlmateriales',
  templateUrl: './listadxmlmateriales.component.html',
  styleUrls: ['./listadxmlmateriales.component.css']
})
export class ListadxmlmaterialesComponent implements OnInit {

  
  archivo: File | null = null;
  archivosXML: File[] = [];
indiceXMLActual = 0;
  facturasMateriales: any = [];
  empleado: any = [];

  // OBJETO COMPLETO
  xmlPreview: any = {
    // Campos que vienen y van a tabla facturas
    folio: '',
    subtotal: '',
    total: '',
    rfc_emisor: '',
    nombre_emisor: '',
    rfc_receptor: '',
    nombre_receptor: '',
    uuid: '',                // clave foránea
    fecha_timbrado: '',
  
    // Campos que vienen y van a "facturas_materiales"
    comentarios: '',
    estado_cfdi: 'VIGENTE',
    fecha_guardado: '',
  
    id: null,                // id de facturas_materiales
  };


facturasmanual: Facmanual = {
  nombreempleado:'',
  fecha_timbrado:'',
  folio:'',
  rfc_emisor:'AAAA111111ZZZ',
  total:0,
  numempleado:0
}



  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;


  dtOptions: DataTables.Settings = {};  
  dtTrigger: Subject<any> = new Subject<any>();
  dtInitialized = false;
  
  // Para controlar el título del modal si es modo edición o no
  esModoEdicion = false;
//////////////////
empleadoFiltrado:any = [];
busquedaEmpleado='';
rfcEmpleado='';


constructor(
    private inventarioService: InventarioService,
    private msj: mensajeSesionExpiradaService,
    private router: Router
  ) { }

   ngOnInit(): void {

    $.extend(true, $.fn.dataTable.Buttons.defaults.dom.button, {
      className: 'btn'   // forza a usar bootstrap en los botones de DataTables
    });

this.dtOptions = {
  pagingType: 'full_numbers',
  pageLength: 10,
  processing: true,
  dom: 'Bfrtip',
  language: {
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ registros",
    info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
    paginate: {
      first: "Primero",
      last: "Último",
      next: "Siguiente",
      previous: "Anterior"
    }
  }
} as DataTables.Settings;


(this.dtOptions as any).buttons = [
  {
    extend: 'excelHtml5',
    text: '<i class="fa fa-file-excel-o"></i> Exportar Excel',
    className: 'btn btn-outline-success btn-sm',
    title: 'Listado_Facturas_Recursos_Materiales',
    exportOptions: {
      columns: [0,1,2,3,4,5,6,7]
    }
  }
];
    
    this.getXMLlista();
    this.getEmpleadoss();

  }
  
 ngOnDestroy(): void {
    if (this.dtTrigger) {
      this.dtTrigger.unsubscribe();
    }
  }

  /** SOLO PARA PRUEBAS
  getXMLlista() {
    this.inventarioService.getFacturasMateriales().subscribe(res => {
      if (res === "TOKEN-EXPIRADO") {
        this.msj.tokenExpiradoCerrarSesion();
        return;
      }
  
      this.facturasMateriales = res;
  
      if (!this.dtInitialized) {
        this.dtTrigger.next(null);
        this.dtInitialized = true;
      }
    });
  }**/


    getXMLlista() {
      this.inventarioService.getFacturasMateriales().subscribe(res => {
        console.log('Respuesta completa del backend:', res);
        console.table(res);
    
        if (res === "TOKEN-EXPIRADO") {
          this.msj.tokenExpiradoCerrarSesion();
          return;
        }
    
        this.facturasMateriales = res || [];  // asegúrate de que sea array
    
        // Siempre destruir y reconstruir para forzar actualización
        if (this.dtElement && this.dtElement.dtInstance) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.clear().draw();     // limpia la tabla actual
            dtInstance.destroy();          // destruye completamente
            this.dtTrigger.next(null);     // reconstruye desde cero
          });
        } else {
          this.dtTrigger.next(null);
          this.dtInitialized = true;
        }
      }, err => {
        console.error('Error al cargar lista:', err);
        this.facturasMateriales = [];
        this.dtTrigger.next(null);
      });
    }

    /** Método forzar la re-renderización completa de la tabla 
     * cuando los datos han cambiado de forma significativa 
     * y el componente no logra actualizar la tabla de manera automática
     */
    rerenderDataTable(): void {
      if (this.dtElement && this.dtElement.dtInstance) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();           // destruye la instancia anterior
          this.dtTrigger.next(null);      // vuelve a dibujar
        });
      }
    }    

// abrirAgregarXML() {
//    $('#Agrexml').modal('show');
//  }

abrirAgregarXML() {
  $('#Agrexml').modal('show');

  // LIMPIEZA TOTAL
  const fileInput = document.getElementById('xmlFile') as HTMLInputElement;
  if (fileInput) fileInput.value = '';

this.archivo = null;
this.archivosXML = [];
this.indiceXMLActual = 0;
  this.esModoEdicion = false;  // MODO AGREGAR XML

  this.xmlPreview = {
    folio: '', subtotal: '', total: '',
    rfc_emisor: '', nombre_emisor: '',
    rfc_receptor: '', nombre_receptor: '',
    uuid: '', no_certificado_sat: '',
    estado_cfdi: 'VIGENTE',
    comentarios: '',
    motivo_cancelacion: ''
  };
  
  // Regresar al título original al modal de preview
  setTimeout(() => {
    const titulo = document.querySelector('#previewXML .modal-title-asig') as HTMLElement;
    if (titulo) {
      titulo.innerHTML = '<i ></i>Previsualización de datos de la factura';
    }
  }, 200);
}

//  cerrarAgregarXML() {
//    $('#Agrexml').modal('hide');
//  }

cerrarAgregarXML() {
  $('#Agrexml').modal('hide');

  // Forzar limpieza del input
  setTimeout(() => {
    const fileInput = document.getElementById('xmlFile') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.archivo = null;
  }, 300);
}

  cerrarPreviewXML() {
    $('#previewXML').modal('hide');
  }

onFileSelected(event: any) {

  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  // MAXIMO 5
  if (input.files.length > 5) {

    Swal.fire({
      icon: 'warning',
      title: 'Máximo 5 XML',
      text: 'Solo puedes seleccionar hasta 5 archivos XML'
    });

    this.resetFileInput();
    return;
  }

  this.archivosXML = Array.from(input.files);
  this.indiceXMLActual = 0;

  // VALIDAR XML
  const invalidos = this.archivosXML.filter(
    x => !x.name.toLowerCase().endsWith('.xml')
  );

  if (invalidos.length > 0) {

    Swal.fire({
      icon: 'error',
      title: 'Archivo inválido',
      text: 'Todos los archivos deben ser XML'
    });

    this.resetFileInput();
    return;
  }

  // ABRIR EL PRIMER XML
  this.cargarXMLActual();
}
  
cargarXMLActual() {

  if (this.indiceXMLActual >= this.archivosXML.length) {

    Swal.fire({
      icon: 'success',
      title: 'Finalizado',
      text: 'Todos los XML fueron revisados'
    });

    this.resetFileInput();
    this.getXMLlista();

    return;
  }

  const archivoActual = this.archivosXML[this.indiceXMLActual];

  this.archivo = archivoActual;

  const reader = new FileReader();

  reader.onload = () => {

    const xmlText = reader.result as string;

    this.parseXML(xmlText);

    if (this.xmlPreview.uuid) {

      $('#Agrexml').modal('hide');

      setTimeout(() => {
        $('#previewXML').modal('show');
      }, 300);

    } else {

      Swal.fire({
        icon: 'error',
        title: 'XML inválido',
        text: `No se encontró UUID en ${archivoActual.name}`
      });

      this.indiceXMLActual++;
      this.cargarXMLActual();
    }
  };

  reader.readAsText(archivoActual, 'UTF-8');
}


  // Método auxiliar para limpiar el input
  private resetFileInput() {
    const fileInput = document.getElementById('xmlFile') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.archivo = null;
  }

  // EXTRAER DATOS DEL XML!
parseXML(xmlString: string) {

  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlString, "text/xml");

  const comprobante = xml.getElementsByTagName("cfdi:Comprobante")[0];
  const emisor = xml.getElementsByTagName("cfdi:Emisor")[0];
  const receptor = xml.getElementsByTagName("cfdi:Receptor")[0];
  const timbre = xml.getElementsByTagName("tfd:TimbreFiscalDigital")[0];

  // SOLO TOMAR LOS IMPUESTOS GLOBALES
  const impuestosGlobales = xml.getElementsByTagName("cfdi:Impuestos")[0];

  let subtotal = parseFloat(comprobante?.getAttribute("SubTotal") || "0");
  let total = parseFloat(comprobante?.getAttribute("Total") || "0");
  let descuento = parseFloat(comprobante?.getAttribute("Descuento") || "0");

  let base16 = 0;
  let iva16 = 0;
  let base0 = 0;
  let impuestos = 0;
  let isrRetenido = 0;

  // TRASLADOS GLOBALES
  const trasladosGlobales =
    impuestosGlobales?.getElementsByTagName("cfdi:Traslado") || [];

  for (let i = 0; i < trasladosGlobales.length; i++) {

    const tasa = trasladosGlobales[i].getAttribute("TasaOCuota");
    const base = parseFloat(
      trasladosGlobales[i].getAttribute("Base") || "0"
    );

    const importe = parseFloat(
      trasladosGlobales[i].getAttribute("Importe") || "0"
    );

    impuestos += importe;

    // IVA 16
    if (tasa === "0.160000") {
      base16 += base;
      iva16 += importe;
    }

    // TASA 0
    if (tasa === "0.000000") {
      base0 += base;
    }
  }

  // RETENCIONES GLOBALES
  const retencionesGlobales =
    impuestosGlobales?.getElementsByTagName("cfdi:Retencion") || [];

  for (let i = 0; i < retencionesGlobales.length; i++) {

    const impuesto =
      retencionesGlobales[i].getAttribute("Impuesto");

    const importe = parseFloat(
      retencionesGlobales[i].getAttribute("Importe") || "0"
    );

    // ISR
    if (impuesto === "001") {
      isrRetenido += importe;
    }
  }

  this.xmlPreview = {

    folio: comprobante?.getAttribute("Folio") || '',

    subtotal: subtotal.toFixed(2),

    descuento: descuento.toFixed(2),

    total: total.toFixed(2),

    // IMPUESTOS
    base16: base16.toFixed(2),
    iva16: iva16.toFixed(2),
    base0: base0.toFixed(2),
    impuestos: impuestos.toFixed(2),
    isr: isrRetenido.toFixed(2),

    rfc_emisor: emisor?.getAttribute("Rfc") || '',
    nombre_emisor: emisor?.getAttribute("Nombre") || '',

    rfc_receptor: receptor?.getAttribute("Rfc") || '',
    nombre_receptor: receptor?.getAttribute("Nombre") || '',

    uuid: timbre?.getAttribute("UUID") || '',

    fecha_timbrado: timbre?.getAttribute("FechaTimbrado") || '',

    no_certificado_sat:
      timbre?.getAttribute("NoCertificadoSAT") || ''
  };
}

  private extract(xml: string, regex: RegExp): string {
  const match = xml.match(regex);
  return match ? match[1].trim() : '';
}

  abrirPreviewXML(factura: any) {
    this.xmlPreview = {
      folio: factura.folio ?? '',
      subtotal: factura.subtotal ?? '',
      total: factura.total ?? '',
      rfc_emisor: factura.rfc_emisor ?? '',
      nombre_emisor: factura.nombre_emisor ?? '',
      rfc_receptor: factura.rfc_receptor ?? '',
      nombre_receptor: factura.nombre_receptor ?? '',
      uuid: factura.uuid ?? '',
      no_certificado_sat: factura.no_certificado_sat ?? '',
      estado_cfdi: factura.estado_cfdi ?? '',
      comentarios: factura.comentarios ?? ''
    };

    $('#previewXML').modal('show');
  }

  confirmarXML() {
    console.log('Modo edición:', this.esModoEdicion);
    console.log('ID que se va a enviar:', this.xmlPreview.id);
    console.log('UUID relacionado:', this.xmlPreview.uuid);
  
    const payloadMateriales = {
      comentarios: this.xmlPreview.comentarios?.trim() || null,
      estado_cfdi: this.xmlPreview.estado_cfdi || 'VIGENTE'
    };
  
    const payloadFacturas = {
      folio: this.xmlPreview.folio || 'S/N',
      subtotal: this.xmlPreview.subtotal || '0',
      total: this.xmlPreview.total || '0',
      rfc_emisor: this.xmlPreview.rfc_emisor || '',
      nombre_emisor: this.xmlPreview.nombre_emisor || '',
      rfc_receptor: this.xmlPreview.rfc_receptor || '',
      nombre_receptor: this.xmlPreview.nombre_receptor || '',
      no_certificado_sat: this.xmlPreview.no_certificado_sat || '',
      fecha_timbrado: this.xmlPreview.fecha_timbrado || ''
    };
  
    console.log('Payload para materiales:', payloadMateriales);
    console.log('Payload para facturas:', payloadFacturas);
  
    if (this.esModoEdicion && this.xmlPreview.id) {
      console.log('→ Actualizando con ID:', this.xmlPreview.id);
  
      this.inventarioService.actualizarFacturaMaterial(this.xmlPreview.id, {
        uuid: this.xmlPreview.uuid,  // Para identificar en facturas
        materiales: payloadMateriales,
        facturas: payloadFacturas    // Envía ambos payloads al backend
      }).subscribe({
        next: (res) => {
          console.log('Respuesta backend (update):', res);
  
          Swal.fire({
            title: '¡Éxito!',
            text: 'Factura actualizada correctamente en ambas tablas',
            icon: 'success',
            timer: 2200,
            showConfirmButton: false,
            toast: true,
            position: 'top-end'
          });
  
          this.cerrarPreviewXML();
          this.getXMLlista();  // Refresca la tabla
        },
        error: (err) => {
          console.error('Error al actualizar:', err);
          this.manejarError(err);
        }
      });
    } else {
      // Creación (nueva factura)
      console.log('→ Creando nueva factura'); 
     const payload = {
  folio: this.xmlPreview.folio || 'S/N',

  subtotal: this.xmlPreview.subtotal || '0',

  descuento: this.xmlPreview.descuento || '0',

  total: this.xmlPreview.total || '0',

  // IMPUESTOS
  base16: this.xmlPreview.base16 || '0',

  base0: this.xmlPreview.base0 || '0',

  iva16: this.xmlPreview.iva16 || '0',

  isr: this.xmlPreview.isr || '0',

  rfc_emisor: this.xmlPreview.rfc_emisor || '',

  nombre_emisor: this.xmlPreview.nombre_emisor || '',

  rfc_receptor: this.xmlPreview.rfc_receptor || '',

  nombre_receptor: this.xmlPreview.nombre_receptor || '',

  uuid: this.xmlPreview.uuid,

   fecha_timbrado: this.xmlPreview.fecha_timbrado || '',

  no_certificado_sat:
    this.xmlPreview.no_certificado_sat || '',

  comentarios:
    this.xmlPreview.comentarios?.trim() || null,

  estado_cfdi:
    this.xmlPreview.estado_cfdi || 'VIGENTE'
};
  
      console.log('→ Creando con payload completo:', payload);
  
      this.inventarioService.guardarFacturaMaterial(payload).subscribe({
  next: (res) => {

    Swal.fire({
      title: '¡Guardado!',
      text: res.message || 'Factura registrada correctamente',
      icon: 'success',
      timer: 1200,
      toast: true,
      position: 'top-end',
      showConfirmButton: false
    });

    // CERRAR MODAL ACTUAL
    $('#previewXML').modal('hide');

    // SIGUIENTE XML
    this.indiceXMLActual++;

    // SI TODAVÍA HAY XML
    if (this.indiceXMLActual < this.archivosXML.length) {

      setTimeout(() => {
        this.cargarXMLActual();
      }, 400);

    } else {

      // TERMINÓ TODO
      this.archivosXML = [];
      this.indiceXMLActual = 0;

      Swal.fire({
        icon: 'success',
        title: 'Proceso terminado',
        text: 'Todos los XML fueron cargados correctamente'
      });

      this.resetFileInput();

      this.getXMLlista();
    }

  },
  error: (err) => this.manejarError(err)
});
       
    }
  }

  // Método auxiliar para no repetir código
  private manejarError(err: any) {
    // ====== ERRORES ENVIADOS COMO FUNCIÓN ======
    if (typeof err === 'function') {
      try {
        err = err(); // ejecutamos para obtener el contenido real
      } catch {
        console.warn("⚠ No se pudo ejecutar el error como función");
      }
    }
  
    console.error("👉 Error real:", err);
    console.table(err.error); // Esta tabla despliega errores de los objetos en la consola del navegador.
    console.log("👉 UUID:", this.xmlPreview.uuid);
  
    const errorMsg =
      err?.error?.message ||
      err?.message ||
      err?.error ||
      "Error desconocido";
  
    //Si el UUID esta repetido
    if (
      err?.status === 400 &&
      typeof errorMsg === "string" &&
      errorMsg.toLowerCase().includes("ya fue registrada")
    ) {
      Swal.fire({
        icon: "warning",
        title: "Factura duplicada",
        html: `
          El <i>UUID</i> <b>${this.xmlPreview.uuid}</b> ya existe en el sistema.
          <br><br>
          No se permiten duplicados.
        `,
        confirmButtonText: "Entendido",
        width: "768px"
      });
  
      return;
    }
  
    Swal.fire("Error", errorMsg, "error");
  }

 abrirSATConInstrucciones() {
    // Copiar datos al portapapeles
    //const datosParaSAT = `UUID: ${this.xmlPreview.uuid}\nRFC Emisor: ${this.xmlPreview.rfc_emisor}\nRFC Receptor: ${this.xmlPreview.rfc_receptor}\nTotal: ${this.xmlPreview.total}`;
    //const datosParaSAT = `${this.xmlPreview.uuid}\n${this.xmlPreview.rfc_emisor}\n${this.xmlPreview.rfc_receptor}\n${this.xmlPreview.total}`;
    const datosParaSAT = `${this.xmlPreview.uuid}`;
    
    // Usar API moderna del portapapeles
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(datosParaSAT)
   //         .then(() => {
   //             this.mostrarModalInstrucciones();
   //})
            //        .catch(() => {
              //            this.mostrarModalInstrucciones();
              //        });
              //} else {
        // Fallback para navegadores antiguos
        //    this.mostrarModalInstrucciones();
    }
    
    // Abrir página del SAT en nueva pestaña
    window.open('https://verificacfdi.facturaelectronica.sat.gob.mx/', '_blank');
}

// mostrarModalInstrucciones() {
// Se Puede mostrar un pequeño modal con instrucciones
// Pero solo se cargan en la ventana del SIGA, no en la del SAT
//    alert('Los datos del CFDI han sido copiados al portapapeles. En la página del SAT, pega los datos en los campos correspondientes.');
//}
// Por ahora no se muestra esta alerta.


// Función para copiar al portapapeles RFCs 
// Función para copiar texto al portapapeles
async copiarAlPortapapeles(texto: string): Promise<void> {
  if (!texto?.trim()) return;

  // Intentamos el método moderno (solo funciona en HTTPS o localhost)
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(texto);

      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
      title: 'Copiado al portapapeles',
        showConfirmButton: false,
        timer: 2200,
        background: '#720f3c',
        color: '#ffffff',
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      });

      return;
    } catch (err) {
      console.warn('Clipboard API falló:', err);
      // seguimos al fallback
    }
  } else {
    console.warn('navigator.clipboard no está disponible (probablemente HTTP no-localhost)');
  }

  // Función clásica (funciona en HTTP)
  const fallback = () => {
    const textArea = document.createElement('textarea');
    textArea.value = texto;
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: '¡Copiado! (método alternativo)',
          showConfirmButton: false,
          timer: 2200,
          timerProgressBar: true,
        });
      } else {
        throw new Error('execCommand falló');
      }
    } catch (err) {
      console.error('Fallback también falló:', err);
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        title: 'No se pudo copiar automáticamente',
        text: 'Selecciona el texto y presiona Ctrl+C (o Cmd+C en Mac)',
        showConfirmButton: false,
        timer: 4000,
      });
    } finally {
      document.body.removeChild(textArea);
    }
  };

  fallback();
}




onEstadoCfdiChange() {
  if (this.xmlPreview.estado_cfdi !== 'CANCELADO') {
      this.xmlPreview.motivo_cancelacion = '';
  }
}

editarFactura(factura: any) {
  // Copiamos todos los datos
  this.xmlPreview = {
    folio: factura.folio || '',
    subtotal: factura.subtotal || '',
    total: factura.total || '',
    rfc_emisor: factura.rfc_emisor || '',
    nombre_emisor: factura.nombre_emisor || '',
    rfc_receptor: factura.rfc_receptor || '',
    nombre_receptor: factura.nombre_receptor || '',
    uuid: factura.uuid || '',
    no_certificado_sat: factura.no_certificado_sat || '',
    estado_cfdi: factura.estado_cfdi || 'VIGENTE',
    comentarios: factura.comentarios || '',
    motivo_cancelacion: '',
    id: factura.id  // Importante para identificar la factura a editar
  };

  // Activar modo edición
  this.esModoEdicion = true;

  // Abrimos el modal
  $('#previewXML').modal('show');

  // Cambiamos el título y el botón automáticamente
  setTimeout(() => {
    const titulo = document.querySelector('#previewXML .modal-title-asig') as HTMLElement;
    if (titulo) {
      titulo.innerHTML = '<i></i>Editar factura almacenada';
    }
  }, 300);
}

private actualizarTituloModal(titulo: string) {
  const tituloElement = document.querySelector('#previewXML .modal-title-asig') as HTMLElement;
  if (tituloElement) {
    tituloElement.innerHTML = `<i></i>${titulo}`;
  }
}

// Filtrar por estado, vigentes, cancelados, pagados, columna 6 
filtrarPorEstado(estado: string): void {
  this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

    if (!estado) {
      dtInstance.column(6).search('').draw();
    } else {
      dtInstance.column(6).search(estado).draw();
    }

  });
}

///////////////////////////
getEmpleadoss(){

console.log("INICIANDO CARGA EMPLEADOS");

this.inventarioService
.getempleadosss()
.subscribe({

next:(res:any)=>{

console.log("RESPUESTA CRUD");

console.log(res);

console.table(res);

if(res=="TOKEN-EXPIRADO"){

console.log("TOKEN EXPIRADO");

this.msj.tokenExpiradoCerrarSesion();

return;

}

if(!Array.isArray(res)){

console.log("NO ES ARRAY");

return;

}

this.empleado=res;

this.empleadoFiltrado=[...res];

console.log(
"TOTAL:",
this.empleado.length
);

console.log(
"FILTRADOS:"
);

console.table(
this.empleadoFiltrado
);

},

error:(err)=>{

console.log(
"ERROR FRONT EMPLEADOS"
);

console.log(err);

}

});

}

filtrarEmpleado(){

const texto=this.busquedaEmpleado
.toLowerCase()
.trim();

this.empleadoFiltrado=
this.empleado.filter((x:any)=>

x.nompersonal &&
x.nompersonal
.toLowerCase()
.includes(texto)

);

}

seleccionarEmpleado(){

console.log(
"Seleccionado:",
this.facturasmanual.nombreempleado
);

const emp=
this.empleado.find(
(x:any)=>
x.nompersonal===
this.facturasmanual.nombreempleado
);

console.log("ENCONTRADO:");

console.log(emp);

if(emp){

this.facturasmanual.numempleado=
emp.numpersonal;

this.rfcEmpleado=
emp.rfc;

console.log(
"num empleado:",
this.facturasmanual.numempleado
);

}else{

console.log(
"No encontrado"
);

this.rfcEmpleado='';

}

}


subirFacturaManual(){

this.facturasmanual.rfc_emisor='AAAA111111ZZZ';

console.log(
"ENVIANDO AL BACK"
);

console.log(
JSON.stringify(
this.facturasmanual,
null,
2
)
);

this.inventarioService
.subirfactura(
this.facturasmanual
)
.subscribe({

next:(res)=>{

console.log(
"RESPUESTA BACK:"
);

console.log(res);

Swal.fire(
'Guardado correctamente',
'',
'success'
);

setTimeout(() => {
location.reload();
}, 1000);

},

error:(err)=>{

console.log(
"ERROR GUARDAR"
);

console.log(err);

console.log(
err.error
);

Swal.fire(
'Error',
'No se pudo guardar',
'error'
);

}

});

}



eliminarFactura(factura: any) {

  Swal.fire({
    title: '¿Eliminar factura?',
    html: `
      Se eliminará completamente la factura.

      <br><br>

      <b>UUID:</b><br>
      ${factura.uuid || 'SIN UUID'}

      <br><br>

      Esta acción no se puede deshacer.
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33'
  }).then(result => {

    if (!result.isConfirmed) {
      return;
    }

    this.inventarioService.eliminarFactura(
      factura.uuid,
      factura.folio
    ).subscribe({

      next: (res:any) => {

        Swal.fire({
          icon:'success',
          title:'Factura eliminada',
          text:res.message,
          timer:1800,
          showConfirmButton:false
        });

        this.getXMLlista();

      },

      error:(err)=>{

        Swal.fire(
          'Error',
          err.error?.message || 'No se pudo eliminar',
          'error'
        );

      }

    });

  });

}



}
